import { AllocationViewActionIdentifierModel, UliDetailsModel } from '../../models';

export class AllocationViewRegisterActionPrepare {
  public static readonly type = '[AllocationViewRegisterAction] Prepare';

  constructor(public payload: AllocationViewActionIdentifierModel) {}
}

export class AllocationViewRegisterActionUliRegister {
  public static readonly type = '[AllocationViewRegisterAction] Uli Register';

  constructor(
    public payload: {
      uli: UliDetailsModel;
    },
  ) {}
}

export class AllocationViewRegisterActionLoadCarries {
  public static readonly type = '[AllocationViewRegisterAction] Load Carriers';

  constructor(public payload: string) {}
}

export class AllocationViewRegisterActionLoadLoanerPhones {
  public static readonly type = '[AllocationViewRegisterAction] Load Loaner Phones';

  constructor(public payload: { hubId: number; searchStr: string }) {}
}

export class AllocationViewRegisterActionLoadParkingSpots {
  public static readonly type = '[AllocationViewRegisterAction] Load Parking Spots';

  constructor(public payload: number) {}
}

export class AllocationViewRegisterActionSetInitialState {
  public static readonly type = '[AllocationViewRegisterAction] Set Initial State';
}
